document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('template--24658671829315__form-contact');
  if (!form) return;

  const seg              = (location.pathname.split('/')[1] || '').toLowerCase();
  const [lang = 'en', ctry = 'uk'] = seg.split('-');

  const BRAND_ID = 114094505072;

  const TAGS = {
    uk: 'api_webform_footpatrol_gb',
    ie: 'api_webform_footpatrol_ie',
    fr: 'api_webform_footpatrol_fr',
    de: 'api_webform_footpatrol_de',
    nl: 'api_webform_footpatrol_nl',
    it: 'api_webform_footpatrol_it'
  };

  const LOCALE_IDS = { uk: 1, ie: 1, fr: 1, de: 1, nl: 1, it: 1 }; 
  const localeId  = LOCALE_IDS[ctry] ?? LOCALE_IDS.uk;
  const ticketTag = TAGS[ctry]      ?? TAGS.uk;

  const messages = {
    fr: { ok:'Merci, votre message a bien été envoyé.',
          ko:'Une erreur est survenue. Merci de réessayer.' },
    de: { ok:'Danke, deine Nachricht wurde gesendet.',
          ko:'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.' },
    nl: { ok:'Bedankt, je bericht is verzonden.',
          ko:'Er is een fout opgetreden. Probeer het opnieuw.' },
    it: { ok:'Grazie, il tuo messaggio è stato inviato.',
          ko:'Si è verificato un errore. Riprova.' },
    en: { ok:'Thanks, your message has been sent.',
          ko:'An error occurred. Please try again.' }
  };
  const { ok: successMsg, ko: errorMsg } = messages[lang] || messages.en;

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const data = new FormData(form);
    const pick = (keys) => keys.reduce((v, k) => v || (data.get(k) || '').trim(), '');

    const name  = pick(['contact[Nom]', 'contact[Name]', 'contact[Naam]', 'contact[Nome]']);
    const email = pick(['contact[email]']);
    const phone = pick([
      'contact[Téléphone]', 'contact[Phone]', 'contact[Telefoonnummer]',
      'contact[Telefono]', 'contact[Telefonnummer]'
    ]);

    const subject = pick([
      'contact[comment-pouvons-nous-vous-aider]', 'contact[how-can-we-help]',
      'contact[wie-können-wir-helfen]', 'contact[wie-konnen-wir-helfen]',
      'contact[hoe-kunnen-we-helpen]', 'contact[hoe-kunnen-wij-u-helpen]',
      'contact[come-possiamo-aiutare]', 'contact[come-possiamo-aiutarti]'
    ]) || 'Webform – Contact JD';

    let message = pick([
      'contact[Message]', 'contact[Kommentar]', 'contact[Nachricht]',
      'contact[Messaggio]', 'contact[Bericht]'
    ]) || '-';

    const orderNumber = pick([
      'contact[numero-de-commande]', 'contact[order-number]',
      'contact[bestellnummer]', 'contact[numero-dordine]'
    ]);

    const productNumber = pick([
      'contact[numero-de-produit]', 'contact[product-number]',
      'contact[produktnummer]', 'contact[numero-di-prodotto]'
    ]);

    if (orderNumber)   message += `\n\nOrder Number : ${orderNumber}`;
    if (productNumber) message += `\nProduct Number : ${productNumber}`;

    const payload = {
      ticket: {
        subject,
        comment      : { body: message },
        requester    : { name, email },
        brand_id     : BRAND_ID,
        locale_id    : localeId,
        tags         : [ticketTag],
        custom_fields: [
          { id: 114098939131, value: phone },
          { id: 114098000472, value: orderNumber },
          { id: 114098063431, value: productNumber }
        ]
      }
    };


    fetch('https://dat8p977oa.execute-api.eu-central-1.amazonaws.com/prod/submit', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify(payload)
    })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    })
    .then(() => {
      form.innerHTML =
        `<div class="alert bg-success-bg text-success-text">${successMsg}</div>`;
    })
    .catch(err => {
      console.error('SmartAgent error', err);
      form.insertAdjacentHTML('beforeend',
        `<div class="alert mt-4 bg-error-bg text-error-text">${errorMsg}</div>`
      );
    });
  });
});
